var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',{staticClass:"mr-2"},[_c('router-link',{attrs:{"to":{name: 'dashboard'},"exact":""}},[_c('v-img',{attrs:{"max-width":"220","min-width":"100","src":require('../assets/selteclogo.png')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }